<app-product-price-info
    [(productPriceInfos)]="productPriceInfos"
    [deletePriceInfoOnDestroy]="false"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [upDownButtons]="upDownButtons() ?? props.upDownButtons"
    [lineItem]="model"
    [doc]="doc()"
></app-product-price-info>
